module.exports = __webpack_public_path__ + "static/media/flower-4.fff6bf08.svg";